/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateKpiCommand } from '../../models/create-kpi-command';
import { CreateKpiCommandResult } from '../../models/create-kpi-command-result';

export interface ApiKpIsCreateKpiPost$Params {
      body?: CreateKpiCommand
}

export function apiKpIsCreateKpiPost(http: HttpClient, rootUrl: string, params?: ApiKpIsCreateKpiPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateKpiCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiKpIsCreateKpiPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateKpiCommandResult>;
    })
  );
}

apiKpIsCreateKpiPost.PATH = '/api/KPIs/CreateKPI';
